import { createSlice, PayloadAction } from "@reduxjs/toolkit"
import { ForgotPasswordDetails, LoginDetails } from "./types"
import { ErrorInfo, Profile, Resource, Status } from "../../redux/types"

const initialState: Resource<Profile> = {
  status: Status.INIT
}

export const loginSlice = createSlice({
  name: "login",
  initialState: initialState,
  reducers: {
    reset: state => initialState,
    login: (state, action: PayloadAction<LoginDetails>) => {
      state.error = null
      state.status = Status.LOADING
    },
    loginFailure: (state, action: PayloadAction<ErrorInfo>) => {
      state.data = null
      state.error = action.payload
      state.status = Status.ERROR
    },
    loginSuccess: (state, action: PayloadAction<Profile>) => {
      state.data = action.payload
      state.error = null
      state.status = Status.FINISHED
    },
    logout: state => {
      state.status = Status.LOADING
    },
    logoutSuccess: state => {
      state.data = null
      state.error = null
      state.status = Status.FINISHED
    },
    logoutFailure: (state, action) => {
      state.status = Status.ERROR
    },
    resetPassword: (state, { payload }: PayloadAction<ForgotPasswordDetails>) => {

    }
  }
})

export const {
  reset,
  login,
  logout,
  loginFailure,
  loginSuccess,
  logoutSuccess,
  logoutFailure
} = loginSlice.actions

export const selectProfileResource = (state: { profileResource: Resource<Profile> }) => state.profileResource
export default loginSlice.reducer